import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { filter, map, merge, pipe, switchMap, tap } from 'rxjs';

import { Injectable } from '@angular/core';
import { MineFontsGQL } from '@ui/fonts-manager/graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';

import { ZalamoDialogService } from '@ui/zalamo-dialog/zalamo-dialog.service';
import { FontListComponent } from '@ui/fonts-manager/font-list/font-list.component';
import { firstValueFrom } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';

@Injectable({
  providedIn: 'root',
})
export class FontsManagerService {
  constructor(
    private mineFontsGQL: MineFontsGQL,
    private organizationService: OrganizationService,
    private zalamoDialogService: ZalamoDialogService,
  ) {}

  getFonts(refetch = false) {
    return this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) =>
        this.mineFontsGQL
          .watch({
            ...{
              fetchPolicy: refetch ? 'network-only' : 'cache-first',
            },
            variables: {
              organizationId,
            },
          })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map((result) => result.data['mineFonts']['fonts']),
          ),
      ),
    );
  }
  async pickFont(header?: string) {
    const ref = this.zalamoDialogService.openRight(FontListComponent);
    ref.componentInstance.header = header;
    return firstValueFrom(
      merge(
        ref.componentInstance.picked.pipe(
          tap(() => {
            ref.close();
          }),
        ),
        ref.afterClosed().pipe(map(() => null)),
      ),
    );
  }
}
